import type { ReactNode } from 'react';
import { AuthWrapperStyled } from './styled/AuthWrapperStyled';

interface AuthWrapperProps {
    children: ReactNode;
}

function AuthWrapper({ children }: AuthWrapperProps) {
    return <AuthWrapperStyled>{children}</AuthWrapperStyled>;
}

export default AuthWrapper;
